import { useMemo } from 'react'

import { useIsPendingAirdropTxs, usePendingTransactions } from 'state/user/hooks'

import { Description, Text } from './Style'

type Props = {
  totalTxs?: number
  sentCount?: number
  withDescription?: boolean
}

export function TxCounter({ totalTxs, sentCount, withDescription }: Props) {
  const isPending = useIsPendingAirdropTxs()
  const pendingTransactions = usePendingTransactions()

  const pendingTxCount = useMemo(() => {
    return Object.values(pendingTransactions).length
  }, [pendingTransactions])

  const txCounter = useMemo(() => {
    if (!sentCount || !totalTxs) {
      return null
    }
    return `${sentCount} of ${totalTxs}`
  }, [sentCount, totalTxs])

  // ToDo 0xVoushi
  return txCounter ? (
    <>
      {isPending && withDescription && <Text>Your transaction is&nbsp;being processed, please wait</Text>}
      <Text>Sent tx: {txCounter}</Text>
      {isPending && <Description>Pending: {pendingTxCount}</Description>}
    </>
  ) : null
}
